import Noty from 'noty';
import 'assets/vendored/MNotificationBase.css';
import Vue from 'vue';

import MNotification from 'components/Notifications/MNotification/MNotification';

Noty.overrideDefaults({
  callbacks: {
    onTemplate () {
      this.vNode = new Vue({
        render: (h) => h(MNotification, {
          on: {
            closeNoty: () => this.close()
          },
          props: {
            ...this.options
          }
        })
      }).$mount();

      // remove default template DOM elements
      this.barDom.innerHTML = '';

      this.barDom.appendChild(this.vNode.$el);
    },
    afterClose () {
      if (this.vNode) {
        this.vNode.$destroy();
      }
    }
  }
});


function showNotification (options){
  return new Noty({
    timeout: 5000,
    layout: 'bottomRight',
    ...options
  }).show();
}

// for legacy compatibility
showNotification.success = function (options) {
  options.type = 'success';
  options.header = options.title;
  return showNotification(options);
};

showNotification.warning = function (options) {
  options.type = 'warning';
  options.header = options.title;
  return showNotification(options);
};

showNotification.error = function (options) {
  options.type = 'error';
  options.header = options.title;
  return showNotification(options);
};

export {
  showNotification
};
